import { inject, observer } from "mobx-react";
import React from "react";
import TextInput from "../../../sharedComponents/textInput/textInput";
import { ProposalStore } from "../../../../stores/proposalStore";

interface AuthorisedOfwcaProps {
  proposalStore?: ProposalStore;
}

export function AuthorisedOfwca(props: AuthorisedOfwcaProps) {
  return (
    <div className="section authorised-ofwca">
      <div className="label">Uprawniona OFWCA EF</div>
      <TextInput
        value={props.proposalStore!.authorisedOfwca ?? ""}
        disabled={true}
        multiline={true}
        rows={2}
      />
    </div>
  );
}

export default inject("proposalStore")(observer(AuthorisedOfwca));
